import { useMemo } from 'react'
import { Backdrop, CircularProgress } from '@mui/material'
import { useAppSelector } from 'store/hooks'
import { selectCheckresponse } from 'slices/checkresponseSlice'
import { selectDriverSend } from 'slices/driverSendSlice'
import { selectFinishdelivery } from 'slices/finishdeliverySlice'
import { selectStartdelivery } from 'slices/startdeliverySlice'

export const ProgressIndicator = () => {
  const checkresponse = useAppSelector(selectCheckresponse)
  const driverSend = useAppSelector(selectDriverSend)
  const finishdelivery = useAppSelector(selectFinishdelivery)
  const startedlivery = useAppSelector(selectStartdelivery)

  const open = useMemo(
    () => [checkresponse.status, driverSend.status, finishdelivery.status, startedlivery.status].includes('loading'),
    [checkresponse.status, driverSend.status, finishdelivery.status, startedlivery.status]
  )

  return (
    <Backdrop open={open} sx={{ zIndex: 3 }}>
      <CircularProgress sx={{ color: 'grey.200' }} />
    </Backdrop>
  )
}
